import { languageItem } from '@/language/helpers';
import CartExpiryModal from '@/modals/CartExpiryModal.vue';
import ExtendCartTimerModal from '@/modals/ExtendCartTimerModal.vue';
import { openModal } from '@/modals/helpers/api';
export function openCartExpiryModal(onClose) {
    const language = languageItem('cartExpire');
    openModal({
        name: 'cart-expiry-modal',
        title: language.title,
        closeable: false,
        size: 'sm',
        component: CartExpiryModal,
        onClose,
        describedBy: 'cart-expiry-content',
    });
}
export function openExtendCartTimerModal(onClose) {
    const language = languageItem('extendCartTimerModal');
    openModal({
        name: 'extend-cart-timer-modal',
        title: language.title,
        closeable: false,
        size: 'md',
        component: ExtendCartTimerModal,
        onClose,
        describedBy: 'extend-cart-timer-content',
    });
}
